import { AdaptiveLoader } from "@/components/AdaptiveLoader"
import { PopInIcon } from "@/components/icons/PopInIcon"
import { PopOutIcon } from "@/components/icons/PopOutIcon"
import { CurrencyPair } from "@/services/currencyPairs"

import { tearOut } from "../TearOut/tearOut.state"
import { TileStates, useTileState } from "../tile.state"
import { useTileContext } from "../TileContext"
import { useDate } from "./tileHeader.state"

type HeaderProps = {
  date: string
  onClick: () => void
  currencyPair: CurrencyPair
  isTornOut?: boolean
  supportsTearOut?: boolean
  executing?: boolean
}

export const HeaderInner = ({
  currencyPair,
  isTornOut,
  supportsTearOut,
  date,
  executing,
  onClick,
}: HeaderProps) => (
  <div className="relative flex items-center gap-md bg-utility-gray-100 p-md">
    {executing && <AdaptiveLoader size={12} />}
    <p className="text-sm-regular text-tertiary">
      {currencyPair.base}/{currencyPair.terms}
    </p>
    <div className="delivery-date ml-auto transition-[margin-right] duration-200">
      <p className="text-sm-regular text-tertiary">{date}</p>
    </div>
    {supportsTearOut && (
      <button
        className="header-action absolute top-sm right-sm text-quaternary opacity-0 transition-opacity duration-200 hover:text-tertiary"
        onClick={onClick}
        aria-label={
          isTornOut
            ? "Return window to application"
            : "Tear out into standalone window"
        }
      >
        {isTornOut ? <PopInIcon /> : <PopOutIcon />}
      </button>
    )}
  </div>
)

export const TileHeader = () => {
  const { currencyPair, isTornOut, supportsTearOut } = useTileContext()
  const date = useDate(currencyPair.symbol)
  const { status } = useTileState(currencyPair.symbol)

  const onClick = () => {
    tearOut(currencyPair.symbol, !isTornOut)
  }

  return (
    <HeaderInner
      currencyPair={currencyPair}
      date={date}
      isTornOut={isTornOut}
      supportsTearOut={supportsTearOut}
      executing={status === TileStates.Started}
      onClick={onClick}
    />
  )
}
